import { useQuery } from '@tanstack/react-query';
import { getSubmissionWithDetails } from '@lingaai/supabase-client';

export function useSubmissionDetails(submissionId: string | null) {
  return useQuery({
    queryKey: ['submission-details', submissionId],
    queryFn: () => getSubmissionWithDetails(submissionId!),
    enabled: !!submissionId,
  });
}
